/**
 * 我销售的排名列表页面地址
 */
export const RANKING_AUCTION_SALE_LIST_PAGE_PATH = '/auction/ranking/list/sale'
